// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes calendar-tile-wiggle {
  0%, 100% {
    transform: rotate(0.6deg);
  }
  20% {
    transform: rotate(-1deg);
  }
  40% {
    transform: rotate(0.8deg);
  }
  60% {
    transform: rotate(-0.6deg);
  }
  80% {
    transform: rotate(1deg);
  }
}
@keyframes calendar-tile-nope {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70% {
    transform: translateX(-10px);
  }
  20%, 40%, 60% {
    transform: translateX(10px);
  }
  80% {
    transform: translateX(8px);
  }
  90% {
    transform: translateX(-8px);
  }
}
:host {
  display: block;
  height: 100%;
}

:host(.tile--h2) {
  grid-row: span 2;
}

:host(.tile--w2) {
  grid-column: span 2;
}

:host(.tile--today) .tile {
  color: #e5052a;
}
:host(.tile--today) .tile.tile--active:hover {
  background: rgba(255, 255, 255, 0.5);
}

.tile {
  position: relative;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  padding: 1rem;
  border: 0;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: clamp(2rem, 3vw, 3.8rem);
  text-transform: uppercase;
  transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.tile:focus:not(.tile--played),
.tile:hover:not(.tile--played) {
  outline: none;
  background: rgba(255, 255, 255, 0.16);
  transform: translate(-6px, 14px);
  box-shadow: 0 18px 32px rgba(0, 0, 0, 0.2);
  padding: 10px;
}

.tile:disabled {
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.tile:disabled .tile__label,
.tile:disabled .tile__state {
  opacity: 0.6;
}

.tile__label {
  font-size: inherit;
}

.tile__state {
  position: absolute;
  bottom: 0.75rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.9rem;
  letter-spacing: 0.08em;
}

.tile--locked {
  background: rgba(255, 255, 255, 0.04);
  border-style: dashed;
  box-shadow: none;
  padding: 31px 2px 0 0;
  height: 104px;
  background-image: url(https://assets.qnordicsgames.com/image/upload/v1/FINKFCCHRISTMAS26/calendar/door_closed_2.png);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 0 0;
}

.tile--locked:hover,
.tile--locked:focus {
  animation: calendar-tile-nope 0.9s ease-in-out infinite;
  transform-origin: center;
}

.tile--played {
  background: rgba(255, 255, 255, 0.7);
  color: #d40000;
  border-color: #fff;
}

.tile--active {
  animation: calendar-tile-wiggle 2s ease-in-out infinite;
  transform-origin: center;
  background-image: url(https://assets.qnordicsgames.com/image/upload/v1/FINKFCCHRISTMAS26/calendar/door_open_2.png);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 0 0;
  padding: 28px 18px 0 0;
  height: 104px;
}

.tile--active:hover,
.tile--active:focus {
  animation: none;
}

@media (prefers-reduced-motion: reduce) {
  .tile {
    transition: none;
  }
  .tile--active {
    animation: none;
  }
  .tile--locked:hover,
  .tile--locked:focus {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/advent-calendar/components/day-tile/day-tile.component.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE;IAEE,yBAAA;EAHF;EAKA;IACE,wBAAA;EAHF;EAKA;IACE,yBAAA;EAHF;EAKA;IACE,0BAAA;EAHF;EAKA;IACE,uBAAA;EAHF;AACF;AAMA;EACE;IAEE,wBAAA;EALF;EAOA;IAIE,4BAAA;EARF;EAUA;IAGE,2BAAA;EAVF;EAYA;IACE,0BAAA;EAVF;EAYA;IACE,2BAAA;EAVF;AACF;AAaA;EACE,cAAA;EACA,YAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EAIE,cC3DI;AD6CN;AAgBE;EACE,oCAAA;AAdJ;;AAmBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EAGA,SAAA;EACA,qCAAA;EACA,WAAA;EACA,mCAAA;EACA,yBAAA;EACA,8EAAA;EACA,2CAAA;AAlBF;;AAqBA;;EAEE,aAAA;EACA,qCAAA;EACA,gCAAA;EAEA,0CAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAnBF;;AAsBA;;EAEE,YAAA;AAnBF;;AAsBA;EACE,kBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,qCAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,oHAAA;EACA,4BAAA;EACA,qBAAA;EACA,wBAAA;AAnBF;;AAsBA;;EAEE,uDAAA;EACA,wBAAA;AAnBF;;AAsBA;EACE,oCAAA;EACA,cAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,uDAAA;EACA,wBAAA;EACA,kHAAA;EACA,4BAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,aAAA;AAnBF;;AAsBA;;EAEE,eAAA;AAnBF;;AA2BA;EACE;IACE,gBAAA;EAxBF;EA2BA;IACE,eAAA;EAzBF;EA4BA;;IAEE,eAAA;EA1BF;AACF","sourcesContent":["@use '../../../../../../assets/styles/colors' as colors;\n@use '../../../../../../assets/styles/bootstrap-essentials';\n\n@keyframes calendar-tile-wiggle {\n  0%,\n  100% {\n    transform: rotate(0.6deg);\n  }\n  20% {\n    transform: rotate(-1deg);\n  }\n  40% {\n    transform: rotate(0.8deg);\n  }\n  60% {\n    transform: rotate(-0.6deg);\n  }\n  80% {\n    transform: rotate(1deg);\n  }\n}\n\n@keyframes calendar-tile-nope {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  10%,\n  30%,\n  50%,\n  70% {\n    transform: translateX(-10px);\n  }\n  20%,\n  40%,\n  60% {\n    transform: translateX(10px);\n  }\n  80% {\n    transform: translateX(8px);\n  }\n  90% {\n    transform: translateX(-8px);\n  }\n}\n\n:host {\n  display: block;\n  height: 100%;\n}\n\n:host(.tile--h2) {\n  grid-row: span 2;\n}\n\n:host(.tile--w2) {\n  grid-column: span 2;\n}\n\n:host(.tile--today) .tile {\n  //outline: 3px solid #ffcc00;\n  //outline-offset: 4px;\n  //background-color: #fff;\n  color: colors.$red;\n  //box-shadow: 0 0 0 4px rgba(colors.$yellow, 0.4), 0 20px 32px rgba(0, 0, 0, 0.25);\n  &.tile--active:hover{\n    background: rgba(255, 255, 255, 0.5);\n    //background-color: #fff;\n  }\n}\n\n.tile {\n  position: relative;\n  display: grid;\n  place-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 1rem;\n  // border-radius: 16px;\n  // border: 2px solid #fff;\n  border: 0;\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  font-size: clamp(2rem, 3vw, 3.8rem);\n  text-transform: uppercase;\n  transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\n}\n\n.tile:focus:not(.tile--played),\n.tile:hover:not(.tile--played) {\n  outline: none;\n  background: rgba(255, 255, 255, 0.16);\n  transform: translate(-6px, 14px);\n  //transform: translateY(-4px);\n  box-shadow: 0 18px 32px rgba(0, 0, 0, 0.2);\n  padding: 10px;\n}\n\n.tile:disabled {\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.tile:disabled .tile__label,\n.tile:disabled .tile__state {\n  opacity: 0.6;\n}\n\n.tile__label {\n  font-size: inherit;\n}\n\n.tile__state {\n  position: absolute;\n  bottom: 0.75rem;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 0.9rem;\n  letter-spacing: 0.08em;\n}\n\n.tile--locked {\n  background: rgba(255, 255, 255, 0.04);\n  border-style: dashed;\n  box-shadow: none;\n  padding: 31px 2px 0 0;\n  height: 104px;\n  background-image: url(https://assets.qnordicsgames.com/image/upload/v1/FINKFCCHRISTMAS26/calendar/door_closed_2.png);\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 0 0;\n}\n\n.tile--locked:hover,\n.tile--locked:focus {\n  animation: calendar-tile-nope 0.9s ease-in-out infinite;\n  transform-origin: center;\n}\n\n.tile--played {\n  background: rgba(255, 255, 255, 0.7);\n  color: #d40000;\n  border-color: #fff;\n}\n\n.tile--active {\n  animation: calendar-tile-wiggle 2s ease-in-out infinite;\n  transform-origin: center;\n  background-image: url(https://assets.qnordicsgames.com/image/upload/v1/FINKFCCHRISTMAS26/calendar/door_open_2.png);\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 0 0;\n  padding: 28px 18px 0 0;\n  height: 104px;\n}\n\n.tile--active:hover,\n.tile--active:focus {\n  animation: none;\n}\n\n// .tile--selected:not(.tile--played) {\n//   border-color: colors.$yellow;\n//   box-shadow: 0 0 0 3px rgba(colors.$yellow, 0.4);\n// }\n\n@media (prefers-reduced-motion: reduce) {\n  .tile {\n    transition: none;\n  }\n\n  .tile--active {\n    animation: none;\n  }\n\n  .tile--locked:hover,\n  .tile--locked:focus {\n    animation: none;\n  }\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n","$brown: #cca374;\n$green: #00823d;\n$light-brown: #eaedd2;\n$yellow: #ffcc00;\n$red: #e5052a;\n$brand-bg: #f4002c;\n$header-bg: #000000;\n$white: #ffffff;\n$body-text: #ffffff;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
